import { useEffect, useState } from 'react';
import { isPlatform } from '@ionic/react';
import { Share } from '@capacitor/share';

export const useCanShare = () => {

    const [canShare, setCanShare] = useState(false);

    useEffect(() => {
        if (isPlatform('capacitor')) {
            // mobile native
            Share.canShare().then((result: any) => {
                setCanShare(result.value);
            });
        } else if (!isPlatform('desktop')) {
            // mobile web
            setCanShare(navigator.canShare && navigator.canShare({ url: 'https://app.innerhive.com' }));
        }
    }, []);

    return canShare;
};
